import { render, staticRenderFns } from "./Niveles.vue?vue&type=template&id=f1cd2082"
import script from "./Niveles.vue?vue&type=script&lang=js"
export * from "./Niveles.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports